var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 35,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 23,
    rx: 3.5,
    stroke: "#d9d9d9",
    width: 34,
    x: 0.5,
    y: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.625 16.258h-2.12l-1.59-6.066c-.076-.279-.236-.525-.471-.642A6.902 6.902 0 004.5 8.908v-.233h3.416a.89.89 0 01.884.758l.825 4.376 2.119-5.134h2.061zm4.359 0H12.98l1.65-7.583h2.002zm4.24-5.482c.058-.409.412-.642.824-.642a3.732 3.732 0 011.944.35l.353-1.633A5.068 5.068 0 0020.52 8.5c-1.944 0-3.358 1.05-3.358 2.508 0 1.11 1.002 1.692 1.709 2.042.765.35 1.06.584 1 .933 0 .525-.589.759-1.177.759a5.049 5.049 0 01-2.061-.467l-.354 1.633a5.779 5.779 0 002.18.409c2.179.058 3.533-.992 3.533-2.567 0-1.984-2.769-2.1-2.769-2.974zM29 16.258l-1.59-7.583h-1.708a.886.886 0 00-.825.583l-2.944 7h2.061l.412-1.108h2.533l.235 1.108zm-3.003-5.54l.588 2.857h-1.649z",
    fill: "#172b85",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/visa-125c2a044153c19ef458abb1d643d5a6.svg";
export { SvgVisa as Component };